import React from 'react';
import { FaTwitter, FaLinkedin, FaGoodreads } from 'react-icons/fa';
import Navbar from './Navbar';

export const SOCIAL_LINKS = [
  { label: 'X', href: 'https://x.com/vam_saladi', Icon: FaTwitter },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/vamsisaladi99/', Icon: FaLinkedin },
  { label: 'Goodreads', href: 'https://www.goodreads.com/user/show/125421519', Icon: FaGoodreads },
];

const Footer = () => (
  <footer className="site-footer">
    <span>© {new Date().getFullYear()} Vamsi Saladi</span>
    <ul className="site-footer-links">
      {SOCIAL_LINKS.map(({ label, href, Icon }) => (
        <li key={label}>
          <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
            <Icon size={18} aria-hidden="true" />
          </a>
        </li>
      ))}
    </ul>
  </footer>
);

const Layout = ({ children }) => (
  <div className="site">
    <Navbar />
    <main className="site-main">{children}</main>
    <Footer />
  </div>
);

export default Layout;
